import React from 'react';
import ContentLoader from './ThemedContentLoader';

const HomeTeamStat = (props) => (
  <ContentLoader
    style={{ width: '100%' }}
    speed={2}
    width={400}
    height={118}
    viewBox="0 0 400 118"
    {...props}
  >
    <circle cx="36" cy="36" r="24" />
    <rect x="72" y="18" rx="3" ry="3" width="160" height="14" />
    <rect x="72" y="40" rx="3" ry="3" width="88" height="10" />
    <rect x="268" y="24" rx="12" ry="12" width="56" height="24" />
    <rect x="332" y="24" rx="12" ry="12" width="52" height="24" />
    <rect x="16" y="80" rx="3" ry="3" width="64" height="12" />
    <rect x="16" y="98" rx="3" ry="3" width="40" height="8" />
    <rect x="116" y="80" rx="3" ry="3" width="40" height="12" />
    <rect x="116" y="98" rx="3" ry="3" width="48" height="8" />
    <rect x="216" y="80" rx="3" ry="3" width="36" height="12" />
    <rect x="216" y="98" rx="3" ry="3" width="44" height="8" />
    <rect x="316" y="80" rx="3" ry="3" width="36" height="12" />
    <rect x="316" y="98" rx="3" ry="3" width="40" height="8" />
  </ContentLoader>
);

export default HomeTeamStat;
